import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, heroTrust } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-87" data-mp="9k0g9cbeknrr">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" data-id="element-88" data-mp="4lqj4w64bd3i">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-[10px] font-extrabold uppercase tracking-[0.25em] text-grape" data-id="element-89" data-mp="4njnu5x67n8v">
          SIGMA SMART™
        </motion.p>

        <p className="mx-auto mt-3 max-w-2xl font-display text-[22px] font-bold leading-tight text-plum sm:text-[30px]" style={{
        fontFamily: "Montserrat, sans-serif"
      }} data-id="element-90" data-mp="s9zzhikkb8n9">
          REHABILITATE ANY JOINT SAFELY AND PROGRESSIVELY
        </p>

        
        <p className="pb-[15px] font-display text-xs font-bold uppercase tracking-[0.3em] text-plum/60 sm:text-base" style={{
        paddingTop: "9px",
        paddingBottom: "20px"
      }} data-id="element-91" data-mp="382fdzkwc8ydc">
          Complete injury recovery in 60 minutes using a clinical method
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-md" data-id="element-92" data-mp="3o73ouahgps7j">
          <div className="absolute inset-0 -z-10 mx-auto h-64 w-64 translate-y-6 rounded-full bg-grape/20 blur-3xl" aria-hidden="true" data-id="element-93" data-mp="30gzteqefgyrm" />
          <img src="https://cdn.magicpatterns.com/uploads/dPcdMa3ykMzJnq8oqKWKYT/ChatGPT_Image_4_sept_2026,_01_32_14.png" alt="The 360° Injury Rehab Visual System — ebook plus 5 bonuses in digital format" width={1248} height={1248} sizes="(min-width: 640px) 448px, 100vw" fetchPriority="high" decoding="async" className="animate-floaty mx-auto aspect-square w-full max-w-full rounded-2xl object-contain" data-id="element-94" data-mp="35audvw1uxhrr" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-4 text-xs font-semibold uppercase tracking-[0.18em] text-plum/50" style={{
        fontSize: "10px"
      }} data-id="element-95" data-mp="s1rrim0vq2t8">
          ⭐ 4.9 (500+ satisfied professionals and individuals with injuries) · ⚡ Instant access
        </motion.p>

        <div className="mt-8 flex flex-col items-center" data-id="element-96" data-mp="deq7ic5e4y0x">
          <CTAButton href="#value" data-id="element-97" data-mp="1b1ffr3qos6v8">See the 360 system now</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-98" data-mp="1ayjilhmnxm7u">
            COMPLETE INJURY REHABILITATION COMBO 2026. The #1 system for physical education
            teachers, personal trainers, kinesiologists and individuals with injuries who need a
            real, progressive and ready-to-use protocol.
          </p>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-plum-soft sm:text-xl" data-id="element-99" data-mp="3lt740mm25js5">
            Shoulder · Knee · Ankle · Spine · Hip · Elbow
          </motion.h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-100" data-mp="218tols8th4da">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/70 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-101" data-mp="2b0zduu7op7os">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-102" data-mp="2kyvqjqg9sap0" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-103" data-mp="2ozz0jwbmzcib">
            Ebook + 5 bonuses · 150+ pages - Everything you need in one place.
          </p>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-104" data-mp="umhdeaf58hnt">
          {heroTrust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-105" data-mp="zndob7xwx42q">
              <Icon className="h-4 w-4 text-grape" data-id="element-106" data-mp="49jdu72hirn6" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/50 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-107" data-mp="3vjrr04vnnjow">
          🔥 Limited-time offer · Then the price goes back up to $38
        </motion.div>

        <p className="mt-4 inline-flex items-center justify-center gap-1.5 text-xs font-medium text-plum/45" data-id="element-108" data-mp="3rhenzo8alzvt">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-109" data-mp="3mnaf2zfgvhs3" />
          25 people are watching this product right now
        </p>
      </div>
    </header>;
}